import Alerts from '../Profile/Alerts';
import NewspagerCompany from './NewspagerCompany';

const NewspagerProfile = ({
    company,
    coverages,
    coveragesTotal,
    stories,
    alerts,
    news_stories,
}) => {
    const isCompanyJournalist = company?.isJournalist === true;

    if (isCompanyJournalist) {
        return (
            <Alerts
                data={alerts}
                title={news_stories.title}
                empty={{
                    title: news_stories.placeholder_empty,
                    link: {
                        href: '/',
                        title: news_stories.button,
                    },
                }}
            />
        );
    } else {
        return (
            <NewspagerCompany
                {...{
                    coverages,
                    coveragesTotal,
                    stories,
                    news_stories,
                    companySlug: company.slug,
                }}
            />
        );
    }
};

export default NewspagerProfile;
